import { render, staticRenderFns } from "./DisciplinaryEmail.vue?vue&type=template&id=003e3e84"
import script from "./DisciplinaryEmail.vue?vue&type=script&lang=js"
export * from "./DisciplinaryEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports